import { render, staticRenderFns } from "./ReservationConfirmation.vue?vue&type=template&id=6ded7bfa&scoped=true&"
import script from "./ReservationConfirmation.vue?vue&type=script&lang=js&"
export * from "./ReservationConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ReservationConfirmation.vue?vue&type=style&index=0&id=6ded7bfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ded7bfa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VDataTable,VSpacer})
